// alternative-dashboard/mappers/upcomingObligationsMapper.ts
import type {
  DashboardUpcomingPaymentsResponse,
  UpcomingObligationItem,
} from "@/app/types/alterNativeDashboardLayout";

const TRANSACTION_TYPE_LABELS: Record<string, string> = {
  PAY: "Payment",
  BULK: "Bulk Payment",
  WPS: "WPS Payroll",
};

const getTransactionTypeLabel = (transactionType: string): string =>
  TRANSACTION_TYPE_LABELS[transactionType] ?? transactionType;

export const mapUpcomingObligation = (
  raw: DashboardUpcomingPaymentsResponse,
): UpcomingObligationItem => ({
  id: raw.recordId,
  title: getTransactionTypeLabel(raw.transactionType),
  transactionType: raw.transactionType,
  amount: raw.totalAmount,
  currency: raw.debitCurrency,
  paymentDate: raw.paymentDate,
});

export const mapUpcomingObligations = (
  raw: DashboardUpcomingPaymentsResponse[],
): UpcomingObligationItem[] => raw.map(mapUpcomingObligation);
